import { Box, Card, Chip, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import './Holidays.css';
import { useDispatch } from 'react-redux';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import DisabledDatePicker from '../../../../components/DisabledDatePicker';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { SHOW_NOTIFICATION } from '../../../../constants';

const HolidayCard = (props) => {
  const months = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ];
  const weekdays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  const { holidaysList, item, updateHoliday, deleteHoliday, key, index } =
    props;

  useEffect(() => {
    setEditable(false);
  }, [holidaysList]);
  const id = index + 1;
  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;
  const [editable, setEditable] = React.useState(false);
  const [updatedTitle, setUpdatedTitle] = React.useState();
  const [updatedDate, setUpdatedDate] = React.useState(
    new Date(item.date + 'T00:00:00'),
  );
  const [IsError, setIsError] = React.useState(false);
  const [IsTextError, setIsTextError] = React.useState(false);
  const newDate = new Date(item.date + 'T00:00:00');
  const formatted_date =
    newDate.getDate() +
    '-' +
    months[newDate.getMonth()] +
    '-' +
    newDate.getFullYear();
  const weekDay = weekdays[newDate.getDay()];

  const dispatch = useDispatch();

  const onEditClick = () => {
    setUpdatedTitle(item.occasion);
    setUpdatedDate(new Date(item.date + 'T00:00:00'));
    setEditable(true);
  };
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };
  const handleInputChange = (event) => {
    const { value } = event.target;
    setUpdatedTitle(value);
    setIsTextError(false);
  };

  const onDatePickerChange = (value) => {
    if (value !== null) {
      if (value.$y === currentYear || value.$y === nextYear) {
        setUpdatedDate(new Date(value));
        setIsError(false);
      } else {
        setIsError(true);
      }
    }
  };
  const cancelEditable = () => {
    setIsTextError(false);
    setIsError(false);
    setEditable(false);
  };
  const onSaveclick = () => {
    if (!IsError) {
      if (updatedTitle === '' || updatedTitle.trim() === '') {
        setIsTextError(true);
        return;
      }
      updateHoliday(updatedTitle.trim(), updatedDate, item.id);
      setUpdatedTitle(updatedTitle.trim());
      setEditable(false);
    } else {
      dipatchNotification(
        'error',
        `The date should be set between ${currentYear} and ${nextYear}`,
      );
    }
  };

  const onDeleteClick = () => {
    deleteHoliday(item.id);
  };

  return (
    <Card variant="outlined" sx={{ mb: 1 }}>
      <div className="holidaycard-container">
        <div className="holidaycard-content">
          {!editable ? (
            <>
              <div className="holidayTitle">
                <h6>{id}</h6>
                <h6>. {item.occasion}</h6>
              </div>
              <div className="holidaycard-item-date">{formatted_date}</div>
              <div className="holidaycard-item">
                <Chip label={weekDay} color="secondary" variant="outlined" />
              </div>
              {new Date(item.date + 'T00:00:00').getFullYear() >=
                currentYear && (
                <div className="holidays-action-content">
                  <EditIcon
                    color="primary"
                    className="action-icon-cursor"
                    onClick={() => onEditClick()}
                  />
                  <DeleteIcon
                    sx={{ color: '#9c27b0', marginLeft: '20px' }}
                    className="action-icon-cursor"
                    onClick={() => onDeleteClick()}
                  />
                </div>
              )}
            </>
          ) : (
            <>
              <Box
                sx={{
                  width: '75%',
                  display: 'flex',
                  flexDirection: 'row',
                  boxSizing: 'border-box',
                  justifyContent: 'space-between',
                }}
              >
                <TextField
                  error={IsTextError}
                  name="holidayTitle"
                  value={updatedTitle}
                  onChange={handleInputChange}
                  required
                  id="standard-required"
                  label="Holiday Title"
                  sx={{ marginRight: '5px', width: '75%' }}
                  inputProps={{ maxLength: 100 }}
                />
                <DisabledDatePicker
                  onDatePicketInputChange={onDatePickerChange}
                  holidays={holidaysList}
                  value={updatedDate}
                  error={IsError}
                />
              </Box>
              <div className="holidays-action-content">
                <IconButton color="error" onClick={() => cancelEditable()}>
                  <CloseIcon />
                </IconButton>
                <SaveIcon
                  sx={{ marginLeft: '20px' }}
                  className="save-icon-style"
                  onClick={() => onSaveclick()}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </Card>
  );
};

export default HolidayCard;
